<template>
  <footer class="app-footer">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center">
        <div class="footer-copyright">
          &copy; {{ currentYear }} Pre-Boarding. Alle Rechte vorbehalten.
        </div>
        <div class="footer-links">
          <a href="#" class="footer-link">Datenschutz</a>
          <a href="#" class="footer-link">Impressum</a>
          <a href="#" class="footer-link">Kontakt</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.app-footer {
  padding: 1rem 0;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  font-size: 0.875rem;
}

.footer-copyright {
  color: #6c757d;
}

.footer-links {
  display: flex;
  gap: 1.5rem;
}

.footer-link {
  color: #6c757d;
  text-decoration: none;
  transition: color 0.15s ease-in-out;
}

.footer-link:hover {
  color: var(--primary-color, #3490dc);
  text-decoration: none;
}
</style> 